// Browser shim for `mime-types`. Aliased via vite.config.mjs resolve.alias.
//
// Why: `@openhouse-technologies/utils` re-exports `./requests/helpers`,
// which `import mime from 'mime-types'` at module load. The real
// mime-types pulls `require('path')` (a Node built-in) and Rollup's CJS
// plugin marks both as `commonjs-external` — the bundled output then
// fails at module load in the browser with
//   `Failed to resolve module specifier "mime-types"`.
//
// `getFormDataForFile` (the sole consumer of `mime.extension`) is never
// called from the admin-portal source — `grep -rn getFormDataForFile src/`
// returns zero hits. So an empty no-op shim covers the import without
// changing any runtime behavior.
//
// If a future caller actually needs MIME lookup, swap this for `mime/lite`
// (browser-compatible) and update the alias.
const noop = () => ''
const api = {
  extension: noop,
  lookup: noop,
  contentType: noop,
  charset: noop,
  extensions: {},
  types: {},
}
export default api
export const extension = noop
export const lookup = noop
export const contentType = noop
export const charset = noop
